import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/adminLogin',
    name: 'AdminLogin',
    component: () => import('../views/AdminLogin.vue'),
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      {
        path: 'frontSkill',
        name: 'Skill',
        chinese: '使用技術',
        component: () => import('../views/front/FrontSkill.vue'),
        onNav: true,
      },
      {
        path: 'onlinestore',
        name: 'Onlinestore',
        chinese: '線上購物',
        component: () => import('../views/front/Onlinestore.vue'),
        onNav: true,
        children: [
          {
            path: ':category',
            name: 'Category',
            component: () => import('../views/front/Category.vue'),
          },
          {
            path: ':category/:id',
            name: 'Product',
            component: () => import('../views/front/Product.vue'),
          },
        ],
      },
      {
        path: 'news',
        name: 'News',
        chinese: '最新消息',
        component: () => import('../views/front/News.vue'),
        onNav: true,
      },
      {
        path: 'news/:id',
        name: 'NewsDetail',
        chinese: '新聞內容',
        component: () => import('../views/front/Newsdetail.vue'),
        onNav: false,
      },
      {
        path: 'orderinfo',
        name: 'Orderinfo',
        chinese: '購物指南',
        component: () => import('../views/front/Orderinfo.vue'),
        onNav: true,
      },
      {
        path: 'floraltutorial',
        name: 'Tutorial',
        chinese: '花藝課程',
        component: () => import('../views/front/FloralTutorial.vue'),
        onNav: true,
      },
      {
        path: 'contact',
        name: 'Contact',
        chinese: '聯絡我們',
        component: () => import('../views/front/Contact.vue'),
        onNav: true,
      },
      {
        path: 'checkout',
        name: 'Checkout',
        chinese: '結帳',
        component: () => import('../views/front/Checkout.vue'),
        onNav: false,
      },
      {
        path: 'checkout_payment/:orderId',
        name: 'Checkout_payment',
        chinese: '付款頁面',
        component: () => import('../views/front/Payment.vue'),
        onNav: false,
      },
      {
        path: 'login',
        name: 'LoginPage',
        chinese: '登入',
        component: () => import('../views/front/LoginPage.vue'),
        onNav: false,
      },
      {
        path: 'member',
        name: 'Member',
        chinese: '會員專區',
        component: () => import('../views/front/Member.vue'),
        onNav: false,
      },
    ],
  },
  {
    path: '/back',
    component: () => import('../views/Back.vue'),
    children: [
      {
        path: 'BProducts',
        index: 0,
        title: '產品管理',
        component: () => import('../views/back/BProducts.vue'),
      },
      {
        path: 'BAdministrators',
        index: 8,
        title: '管理者管理',
        component: () => import('../views/back/BAdministrators.vue'),
      },
      {
        path: 'BCoupons',
        index: 6,
        title: '優惠券管理',
        component: () => import('../views/back/BCoupons.vue'),
      },
      {
        path: 'BMails',
        index: 4,
        title: '信件匣',
        component: () => import('../views/back/BMails.vue'),
      },
      {
        path: 'BMembers',
        index: 7,
        title: '會員管理',
        component: () => import('../views/back/BMembers.vue'),
      },
      {
        path: 'BNews',
        index: 1,
        title: '最新消息',
        component: () => import('../views/back/BNews.vue'),
      },
      {
        path: 'BOrderinfos',
        index: 3,
        title: '購物指南',
        component: () => import('../views/back/BOrderinfos.vue'),
      },
      {
        path: 'BOrders',
        index: 5,
        title: '訂單管理',
        component: () => import('../views/back/BOrders.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
